"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportSchema = exports.StoredVerificationResultV1Schema = exports.CURRENT_STORED_VERIFICATION_RESULT_SCHEMA_VERSION = exports.ReceivableSchema = exports.VerificationStatusSchema = exports.ReceivableDocumentationSchema = exports.GeneratedDocumentationSchema = exports.ReportEntryStatusIterable = exports.VerificationStatusValues = exports.ReceivableFieldSchema = exports.FieldResultSchema = void 0;
const zod_1 = require("zod");
const DataTapeField_1 = require("../CreditAgreement/DataTapeField");
/**
 * Result of an asset document verification on a receivable field
 */
exports.FieldResultSchema = zod_1.z.object({
    docSanitizedValue: zod_1.z.string(),
    docRawValue: zod_1.z.string(),
    verificationResult: zod_1.z.boolean(),
});
/**
 * A receivable field that has been run through verification
 *
 * `result` is `null` if receivable has not been verified against asset document (typically because no asset document uploaded)
 */
exports.ReceivableFieldSchema = zod_1.z.object({
    field: zod_1.z.string(),
    loanTapeValue: zod_1.z.string(),
    formula: zod_1.z.string(),
    result: exports.FieldResultSchema.nullable(),
});
exports.VerificationStatusValues = [
    'Untested', // no document was uploaded
    'TextractFailed', // document failed to textract or sanitize
    'UnverifiedFailure', // textract succeeded but verification failed for 1 or more fields (no manual edit yet.)
    'VerifiedFailure', // verification failures confirmed by manual edits.
    'Passed', // verification passed
];
exports.ReportEntryStatusIterable = [
    'passed',
    'failed',
    'finley_review', // status subtype of failure (UnverifiedFailure)
    'missing_raw_documentation',
    'missing_generated_documentation',
];
exports.GeneratedDocumentationSchema = zod_1.z.object({
    id: zod_1.z.string(),
    // Unix timestamp in milliseconds epoch, use new Date(timestamp) to read, date.getTime() to write
    timestamp: zod_1.z.number(),
    // if CM left a note on the generated documentation
    note: zod_1.z.string(),
});
exports.ReceivableDocumentationSchema = zod_1.z.object({
    // raw documentations (represents a pdf file)
    rawId: zod_1.z.string(),
    // Unix timestamp in milliseconds epoch, use new Date(timestamp) to read, date.getTime() to write
    timestamp: zod_1.z.number(),
    // latest version of generated documentation corresponding for this raw documentation
    generatedDocumentation: exports.GeneratedDocumentationSchema.nullable(),
});
exports.VerificationStatusSchema = zod_1.z.enum(exports.VerificationStatusValues);
/**
 * A receivable with verification results.
 */
exports.ReceivableSchema = zod_1.z.object({
    finleyReceivableId: zod_1.z.string(),
    externalReceivableId: zod_1.z.string(),
    documentations: zod_1.z.array(exports.ReceivableDocumentationSchema),
    verificationStatus: exports.VerificationStatusSchema,
    fields: zod_1.z.array(exports.ReceivableFieldSchema),
    sampleConfigs: zod_1.z.array(zod_1.z.string()).nullable(), // null implies no sampling config exists
    sampled: zod_1.z.boolean().nullable(), // null implies no verification exists
});
exports.CURRENT_STORED_VERIFICATION_RESULT_SCHEMA_VERSION = 1;
exports.StoredVerificationResultV1Schema = zod_1.z.object({
    // since this is stored as a json blob in db
    // we need to keep track of schema version
    // this basically tells us if the shape of the structure
    // is current or not, and if not, how to convert it to
    schemaVersion: zod_1.z.literal(1),
    // results for each field that
    // we were asked to verify.
    fields: zod_1.z.array(exports.ReceivableFieldSchema),
});
/**
 * Verification report for a specific reporting date spanning all versions of files uploaded for that reporting date
 *
 * This is to ensure capturing all newly assigned receivables across multiple versions of the master loan tape for the same reporting date
 */
exports.ReportSchema = zod_1.z.object({
    reportingDate: zod_1.z.string(),
    receivables: zod_1.z.array(exports.ReceivableSchema),
    baseFieldConfigs: zod_1.z.array(DataTapeField_1.DataTapeField.BaseConfigSchema),
});
//# sourceMappingURL=AssetVerificationOutput.js.map